import { format, setHours, setMinutes, setSeconds } from "date-fns";
import { FormEvent, useState } from "react";
import { toast } from "sonner";
import axiosInstance from "./axiosInstance";

// setFormProp -> setState of form variable

export const handleFormChange = (e: FormEvent<any>, setFormProp: Function) => {
  const { id, value, type } = e.currentTarget;
  setFormProp((prev: any) => {
    return {
      ...prev,
      [id]: type === "number" ? +value || "" : value,
    };
  });
};

export const handleFakeEventChange = (id: string, value: string) => {
  const fakeEvent = {
    currentTarget: {
      id,
      value,
    },
  };

  return fakeEvent;
};

export const autofillEditForm = async (
  resource: string,
  id: number,
  setFormProp: Function,
) => {
  if (!id) return;
  const response = await axiosInstance.get(`/${resource}/${id}`);
  setFormProp(response.data);
};

export const mergeDateAndTime = (date: any, time: any) => {
  if (!date || !time) return null;

  const dateObj = new Date(date);

  const [hoursStr, minutesStr] = time.split(":");
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if (isNaN(dateObj.getTime())) {
    console.error("Invalid date or time");
    return null;
  }

  dateObj.setHours(hours);
  dateObj.setMinutes(minutes);

  return dateObj;
};

export const seperateDateAndTime = (isoString: any) => {
  const dateObj = new Date(isoString);

  dateObj.setHours(dateObj.getHours());

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  const datePart = `${year}-${month}-${day}`;
  const timePart = `${hours}:${minutes}`;

  return {
    datePart,
    timePart,
  };
};

export const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getFormattedDateTime = (
  selectedDate: Date | null,
  selectedTime: any,
) => {
  if (selectedDate && selectedTime) {
    const combined = setSeconds(
      setMinutes(
        setHours(new Date(selectedDate), selectedTime.getHours()),
        selectedTime.getMinutes(),
      ),
      selectedTime.getSeconds(),
    );
    return format(combined, "yyyy-MM-dd HH:mm:ss");
  }
  return null;
};

export const  submitCreateForm = async (resource: string, data: any, refresh: Function, responseMessage?: string) => {
  try {
    await axiosInstance.post(`/${resource}`, data);
    toast(responseMessage || "Record added");
    refresh();
  } catch (err: any) {
    toast(err.response.data.message);
  }
};

export const submitEditForm = async (
  id: number,
  resource: string,
  data: any,
  refresh: Function,
  responseMessage?: any,
) => {
  try {
    await axiosInstance.put(`/${resource}/${id}`, data);
    toast(responseMessage || "Record edited");
    refresh();
  } catch (err: any) {
    toast(err.response.data.message || "An error occured");
  }
};

export const confirmAssingment = async (
  propKey: string,
  currSelected: string,
  endpoint: string,
  id: number,
  refresh: Function,
  setOpenDialog: Function,
  endpoint2?: string,
  responseMessage?: string,
) => {
  const payload: any = {};
  payload[propKey] = currSelected;
  try {
    const finalUrl = endpoint2
      ? `${endpoint}/${id}/${endpoint2}`
      : `${endpoint}/${id}`;
    await axiosInstance.put(finalUrl, payload);
    toast(responseMessage || "Record updated");
    refresh();
    setOpenDialog(false);
  } catch (err: any) {
    console.log(err);
    toast(err.response.data.message);
    setOpenDialog(false);
  }
};
